module.exports = __webpack_public_path__ + "static/media/LR black.2bcbb273.png";